import * as React from 'react';
import { useConfig } from '~/common/context';
import { createLogger, LogLevel } from '~/common/helpers';
// eslint-disable-next-line @wyz/module/no-relative-import
import { LoggerContext } from './contexts';

export function LoggerProvider(props: React.PropsWithChildren) {
  const config = useConfig();

  const logger = React.useMemo(() => {
    const isDevelopment = config.environment !== 'prod';
    const logLevel = isDevelopment ? LogLevel.DEBUG : LogLevel.WARN;

    return createLogger({
      enabled: true,
      level: logLevel,
      prefix: 'WYZ-Connect',
    });
  }, [config.environment]);

  return (
    <LoggerContext.Provider value={logger}>
      {props.children}
    </LoggerContext.Provider>
  );
}

export const useLogger = () => {
  const context = React.useContext(LoggerContext);
  if (context === undefined) {
    throw new Error('useLogger must be used within a LoggerProvider');
  }
  return context;
};
